// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".imgPic[data-v-25540825] {\n  height: var(--height);\n  width: var(--width);\n}\n.imgPic[data-v-25540825]:hover {\n    cursor: pointer;\n}\n.picNum[data-v-25540825] {\n  position: absolute;\n  right: 5px;\n  bottom: 5px;\n  color: white;\n}\n.brand[data-v-25540825] {\n  position: absolute;\n  left: 0;\n  top: 0;\n  padding-left: 3px;\n  padding-right: 3px;\n  padding-top: 1px;\n  padding-bottom: 1px;\n  background: black;\n  color: gold;\n}\n", ""]);
// Exports
module.exports = exports;
